import { ParametersSelection } from './ParametersSelection';
import { ContainerInputProps } from '@/app/features/products/common/components/input-props';
import { getCurrentFeatureCode } from '@/app/core/auth';
import { usaaParametersValidator } from '@ssar-app/domain';

export const Parameters = (props: ContainerInputProps) => {
  const { keys } = props;

  return (
    <ParametersSelection
      stepKey={keys}
      moduleProps={{
        productName: getCurrentFeatureCode() || '',
      }}
      validator={usaaParametersValidator}
    />
  );
};
